<template>
  <div class="edit-video-box">
    <el-dialog :title="'新增自动上架'" :visible.sync="dialogVisible" width="500px" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form ref="form" :model="param" label-position="left" label-width="100px">
        <div class="form-flex-box" v-if="diaType == 'batch'">
          <el-form-item label="价格:" prop="vid">
            <el-input v-model="param.coins" size="small" placeholder="请输入帖子价格"></el-input>
          </el-form-item>
        </div>
        <!-- <div class="form-flex-box">
          <el-form-item label="模块ID:" prop="sectionID">
            <el-input
              v-model="param.sectionID"
              size="small"
              placeholder="请输入模块ID"
            ></el-input>
          </el-form-item>
        </div> -->

        <el-form-item label="父专题:" prop="start">
          <el-select v-model="moduleID" placeholder="请选择父专题" size="small" clearable @change="searchSelectSection">
            <el-option v-for="(section, index) in sections" :key="index" :label="section.moduleName"
              :value="section.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="子专题:" prop="start">
          <el-select v-model="param.sectionID" placeholder="请选择子专题" size="small" clearable>
            <el-option v-for="(subSection, index) in searchSubSections" :key="index" :label="subSection.sectionName"
              :value="subSection.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上架时间:" prop="reviewAt">
          <el-date-picker
            v-model="param.reviewAt"
            type="datetime"
            :editable="false"
            placeholder="请选择上架时间"
            size="small"
          ></el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitDate()" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      diaTitle: "帖子自动上线新增",
      diaType: "add",
      vids: [],
      param: {
        vids: "",
        sectionID: "",
        start: "",
        end: "",
        coins: undefined,
      },
      moduleID: '',
      sections: [],
      // rules: {
      //   vid: [{ required: true, message: "请输入帖子id", trigger: "blur" }],
      // },
    };
  },
  computed: {
    searchSubSections() {
      if (!this.moduleID) return []
      const sub = this.sections.find(v => v.id === this.moduleID)
      if (sub) {
        return sub.allSection
      }
      return []
    }
  },
  created() {
    this.getSections();
  },
  methods: {
    searchSelectSection() {
      this.param.sectionID = "";
    },
    getSections() {
      API.sectionList({}).then((res) => {
        if (res && res.code === 200) {
          this.sections = res.data;
          console.log(this.sections);
        }
      });
    },
    // 提交
    submitDate() {
      this.param.coins = this.param.coins ? Number(this.param.coins) : undefined;
      API.addVidTimeOnline(this.param)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功！",
              type: "success",
            });
          } else {
            this.$message.error("新增失败！");
          }
          this.flag = false;
          this.handleClose(true);
        })
        .catch(() => {
          this.flag = false;
          // this.handleClose();
        });
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.dialogVisible = true;
      this.param.vid = row.id;
    },
    // 关闭回掉
    handleClose(succeed) {
      this.dialogVisible = false;
      this.moduleID = "";
      this.param.sectionID = "";
      this.param = {
        vids: undefined,
        sectionID: "",
        start: "",
        end: "",
        coins: undefined,
      };
      this.$emit("batchClose", typeof succeed === 'boolean' ? succeed : false);
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 300px;
  }

  .el-select {
    width: 300px;

    /deep/ .el-input {
      width: 300px;
    }
  }

  .activity-box {
    /deep/ .el-input {
      width: 500px !important;
    }
  }

  .form-flex-box {
    display: flex;

    .el-form-item {
      flex: 1;
    }
  }
}
</style>
